/**
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint no-use-before-define:0*/
/*eslint no-lonely-if:0*/
/*eslint no-negated-condition:0*/
/*eslint max-lines:0*/


var Page = require('stb-component-page'),
    page = new Page({$node: document.getElementById('pageChannels')}),
    app = require('mag-app'),
    format = require('cjs-format'),
    utils = require('../modules/utils'),
    PanelSet = require('mag-component-panel-set'),
    Panel = require('mag-component-panel'),
    LayoutList = require('mag-component-layout-list'),
    RadioList = require('mag-component-radio-list'),
    ModalMessage = require('mag-component-modal'),
    ScrollBar = require('stb-component-scrollbar'),
    Footer = require('mag-component-footer'),
    provider = app.provider,
    keys = require('stb-keys'),
    // lastSendCtx,
    scrollbars = {
        channelList: new ScrollBar(),
        categoryList: new ScrollBar(),
        epg: new ScrollBar()
    },
    iconList = require('../modules/modal.icons'),
    appUIPanels = [],
    //
    //channels = [],
    keyblock = false,
    //HIDE_FLAG = false,
    KEYBLOCK_REVERT_TIMOUT = 1500,
    keyblockRevertTimeout = null,
    titleWidget = require('../modules/title.widget'),
    tv = {
        config: {
            favorite: false,
            byName: false,
            genre: false,
            search: ''
        },
        lastActiveState: {
            config: {
                favorite: false,
                byName: false,
                genre: false,
                search: ''
            }
        },
        list: [],
        epg: {
            list: [],
            currentPlayIndex: 0
        },
        current: null,
        currentIndex: undefined,
        // timeout to update epg program
        epgTimeout: null,
        footerInitDelay: null,
        // timeout to reinit epg list
        epgUpdateTimeout: null,
        context: null,
        lastChannelTimeout: null,
        channelFooterTimeout: null,
        channelListEpgTimeout: null,
        channelListEpgInterval: null
    },
    menuItems,
    mainSet,  categoryModalList,
    channelList, programList, menuList, leftPanel, channelPanel, epgPanel,
    categoryList, sortList, channelActionModal, footer, epgMenu, actionModalList, exitModal, resetModal,
    $channelsCount = document.createElement('div'),
    $channelsCountWrapper = document.createElement('div'),
    $nowDate = document.createElement('div'),
    $noEpg = document.createElement('div'),
    // const
    CURRENT_EPG_UPDATE_INTERVAL = 60000 * 5,
    antennaEnable = !!app.provider.antennaPower,
    // how long notification will be shown
    CHANNELS_UPDATE_NOTIFICATION_TIMEOUT = 7000,
    // damn hardcode flag turn on after pip
    NEED_SILENCE = false,
    LAST_CHANNEL_TIMEOUT = 1000;


function closeOpenedIntents ( intents ) {
    // close existing osd intents
    intents.forEach(function ( intent ) {
        if ( intent !== null ) {
            intent.close();
        }
    });
}


/**
 * State of app is in foreground
 * @type {boolean} state
 */
app.foreground = true;

if ( TARGET === 'dvb' ) {
    app.provider.addListener('scanning:stop', function () {
        updateChannelList();
    });
    app.provider.addListener('channels:update', function () {
        updateChannelList();
    });
    app.provider.addListener('epg:update', function () {
        if ( channelList.$focusItem ) {
            channelList.$focusItem.data.value.getEpg(null, renderEpgList);
        }
    });
    app.provider.addListener('antennaPower', function ( enable ) {
        antennaEnable = enable;
        initFooterOnChannelSelect();
        renderActionModal();
        menuList.$body.children[2].children[0].children[0].className = 'theme-icon ' +
            ( antennaEnable ? 'theme-icon-dvb-power-on' : 'theme-icon-dvb-power-off' );
    });
}

// need to stop player if app was closed by task manager
// @deprecated
core.addListener('close', onExitAppHandler);
core.addListener('exit', onExitAppHandler);

core.addListener('hide', function ( event ) {
    console.log('tv-app hide', 'event.action:' + event.source);
    if ( event.source === core.SOURCES.INTENT && event.data && event.data.intent && event.data.intent.action === 'play' ) {
        // do nothing
        console.log(event, 'core.SOURCES.INTENT');
        app.foreground = false;
    } else {
        console.log('tv-app emit exit');
        if ( app.lastIntent ) {
            app.lastIntent.emit('exit');
        }
        if ( isSortingDifferent() ) {
            resetFilters(tv.lastActiveState.config);

            tv.config.favorite = tv.lastActiveState.config.favorite;
            tv.config.genre = tv.lastActiveState.config.genre;
            tv.config.search = tv.lastActiveState.config.search;
            tv.config.byName = tv.lastActiveState.config.byName;
        }
    }
});

core.addListener('show', function ( event ) {
    var silentState = app.foreground,
        contextState = app.foreground ? tv.context : null;

    console.log('SHOW!!!');
    console.log(event);

    if ( (event.source === core.SOURCES.INTENT && event.data && event.data.intent && event.data.intent.action === 'play')
        || (event.source === core.SOURCES.SYSTEM && event.data && event.data.intent && event.data.intent.action !== 'record')
    ) {
        app.foreground = true;
        // app shown by intent.show() , it's just swap
        // hide osd intent if present
        if ( app.intents.osdTv ) {
            app.intents.osdTv.close();
            app.intents.osdTv = null;
        }
        channelList.focusIndex(tv.currentIndex);

        // update epg for visible channels in list and epg of current channel
        updateChannelListEpg();
        clearTimeout(tv.epgTimeout);
        if ( !channelList.$focusItem ) {
            return;
        }
        tv.epgTimeout = setTimeout(function () {
            if ( !channelList.$focusItem ) {
                return;
            }
            tv.list[channelList.$focusItem.index].getEpg(null, function ( error, data ) {
                renderEpgList(error, data);
                initFooterOnEpgSelect();
            });
        }, 800);
    } else {
        if ( tv.list[tv.currentIndex] && !tv.list[tv.currentIndex].censored &&
            ( !tv.list[tv.currentIndex].genre || !tv.list[tv.currentIndex].genre.censored )) {
            setChannel(tv.currentIndex, {silent: silentState, context: contextState, force: true});
        } else {
            tv.currentIndex = null;
            tv.current = null;
        }
    }
});

page.add(
    categoryList = new ModalMessage({
        visible: false,
        title: gettext('Categories'),
        className: 'categoryList',
        events: {
            show: function () {
                this.focus();
                this.children[0].focus();
                setTimeout(function () {
                    footer.hide();
                }, 0);
            },
            hide: function () {
                leftPanel.focus();
            }
        },
        children: [
            categoryModalList =  new LayoutList({
                size: 5,
                cycle: true,
                // fixedData: true,
                scroll: scrollbars.categoryList,
                className: 'padded',
                events: {
                    'click:item': function ( event ) {
                        var $icon = menuList.$body.children[2].children[0].children[0];

                        categoryList.hide();

                        tv.config.genre = event.$item.data.value.id;
                        // left menu list
                        leftPanel.children[0].$focusItem.layout.$node.children[1].innerText = event.$item.data.value.name;
                        if ( event.$item.index ) {
                            $icon.classList.add('active');
                        } else {
                            $icon.classList.remove('active');
                        }
                        updateChannelList(function () {
                            // categoryList.hide();
                            leftPanel.focus();
                        });
                    },
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                categoryList.hide();
                                event.stop = true;
                                break;
                            case keys.f1:
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    }),
    sortList = new ModalMessage({
        visible: false,
        title: gettext('Sort'),
        events: {
            show: function () {
                this.focus();
                this.children[0].focus();
                footer.hide();
            },
            hide: function () {
                leftPanel.focus();
            }
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 2,
                cycle: true,
                data: [
                    {
                        state: true,
                        title: gettext('By number'),
                        value: false
                    },
                    {
                        state: false,
                        title: gettext('By name'),
                        value: true
                    }
                ],
                events: {
                    select: function ( $item ) {
                        leftPanel.children[0].$focusItem.layout.$node.children[1].innerText = $item.data.title;
                        tv.config.byName =  $item.data.value;
                        updateChannelList();
                    },
                    'click:item': function () {
                        sortList.hide();
                        leftPanel.focus();
                    },
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                sortList.hide();
                                event.stop = true;
                                break;
                            case keys.f1:
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    })
);

page.once('show', function () {
    app.pages.epg.addListener('channel:click', function ( data ) {
        console.log(data);
        setChannel(data.channelIndex);
    });
    app.pages.epg.addListener('epg:click', sendEpgPlayIntent);
});

footer = new Footer({
    parent: page,
    data: {
        middle: []
    }
});
footer.show();

menuItems = [
    {
        name: 'search',
        items: [
            {
                className: 'theme-icon theme-icon-search',
                name: '$icon'
            },
            {
                value: gettext('Search'),
                name: '$text'
            }
        ],
        click: function () {
            core.intent({
                action: 'keyboard',
                data: {
                    type: 'text',
                    icon: null,
                    title: gettext('TV channel search'),
                    value: tv.config.search
                },
                events: {
                    done: function ( event ) {
                        if ( event.value && tv.config.search !== event.value ) {
                            tv.config.search = event.value;
                            menuList.links.search.links.$text.innerText = event.value;
                            menuList.links.search.links.$icon.classList.add('active');
                            updateChannelList();
                        } else if ( !event.value || !event.value.trim() ) {
                            menuList.links.search.links.$text.innerText = gettext('Search');
                            menuList.links.search.links.$icon.classList.remove('active');
                            if ( tv.config.search !== event.value ) {
                                tv.config.search = event.value;
                                updateChannelList();
                            }
                        }


                    }
                }
            });
        }
    },
    {
        name: 'favorite',
        items: [
            {
                className: 'theme-icon theme-icon-favorite',
                name: '$icon'
            },
            {
                value: gettext('Favorite'),
                name: '$text'
            }
        ],
        click: function () {
            if ( tv.config.favorite ) {
                menuList.links.favorite.links.$icon.className = 'theme-icon theme-icon-favorite';
            } else {
                menuList.links.favorite.links.$icon.className = 'theme-icon theme-icon-favorite-active active';
            }
            tv.config.favorite = !tv.config.favorite;
            updateChannelList();
        }
    },
    {
        name: 'sort',
        items: [
            {
                className: 'theme-icon theme-icon-sort-az',
                name: '$icon'
            },
            {
                value: gettext('By number'),
                className: 'theme-item-more',
                name: '$text'
            }
        ],
        click: function () {
            mainSet.blur();
            sortList.show();
        }
    },
    {
        items: [
            {
                className: 'theme-icon theme-icon-exit'
            },
            {
                value: gettext('Exit')
            }
        ],
        click: function () {
            mainSet.blur();
            exitModal.show();
        }
    }
];

// add ability to sort by categories
if ( MODE === 'MINISTRA' ) {
    menuItems.splice(2, 0, {
        name: 'categories',
        items: [
            {
                className: 'theme-icon theme-icon-categories',
                name: '$icon'
            },
            {
                value: gettext('All categories'),
                className: 'theme-item-more',
                name: '$text'
            }
        ],
        click: function () {
            leftPanel.blur();
            categoryList.show();
            setTimeout(function () {
                categoryList.show();
            }, 50);
        }
    });
}

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    menuItems.splice(4, 0, {
        name: 'resetFilters',
        items: [
            {
                className: 'theme-icon theme-icon-reset-filters',
                name: '$icon'
            },
            {
                value: gettext('Reset filters'),
                name: '$text'
            }
        ],
        click: resetFilters
    });
}

if ( TARGET === 'dvb' ) {
    menuItems.splice(2, 0, {
        items: [
            {
                className: 'theme-icon ' + ( antennaEnable ? 'theme-icon-dvb-power-on' : 'theme-icon-dvb-power-off' )
            },
            {
                value: gettext('Scan DVB channels'),
                className: 'theme-item-more'
            }
        ],
        click: function () {
            app.route(app.pages.scanOptions);
        }
    });
}


// channels count prepare html
$channelsCountWrapper.className = 'amountContainer';
$channelsCount.className = 'amount';
$channelsCount.innerText = 0;
$channelsCountWrapper.appendChild($channelsCount);
$nowDate.id = 'currentDate';


appUIPanels = [
    leftPanel = new Panel({
        title: gettext('Menu'),
        events: {
            focus: function ( event ) {
                Panel.prototype.defaultEvents.focus.call(this, event);

                updateFooterLater(
                    {
                        middle: [
                            {
                                code: keys.f1,
                                title: gettext('Reset filters'),
                                action: function () {
                                    resetFilters(null, true);
                                }
                            }
                        ],
                        left: {
                            code: keys.menu,
                            action: function () {
                                resetModal.show();
                            }
                        }
                    }
                );
                footer.show();
                //footer.hide();
            }
        },
        children: [
            menuList = new LayoutList({
                focusIndex: 0,
                cycle: true,
                data: menuItems,
                size: menuItems.length
            })
        ]
    })
];

menuList.addListener('keydown', keydownHandlerForOsdInput);

appUIPanels = appUIPanels.concat(
    [
        channelPanel = new Panel({
            title: [{value: gettext('Channel list'), className: 'name'}, $channelsCountWrapper],
            main: true,
            className: 'channelPanel',
            events: {
                focus: function ( event ) {
                    Panel.prototype.defaultEvents.focus.call(this, event);
                    initFooterOnChannelSelect();
                }
            }
        }),
        epgPanel = new Panel({
            title: [gettext('TV program'), $nowDate],
            children: [
                programList = new LayoutList({
                    size: 7,
                    className: 'programList',
                    // fixedData: true, // something went wrong when try to scroll list to the end
                    noData: $noEpg,
                    scroll: scrollbars.epg,
                    //cycle: true,
                    events: {
                        keydown: function ( event ) {
                            var current = programList.$focusItem,
                                next;

                            switch ( event.code ) {
                                case keys.up:
                                    next = programList.data[current.index - 1];
                                    if ( current.index > 0 && next && next.value ) {
                                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                                    } else if ( programList.data[current.index - 2]) {
                                        programList.focusIndex(current.index - 2);
                                    }
                                    if ( programList.$focusItem && programList.$focusItem.data.value && programList.$focusItem &&
                                        programList.$focusItem.data && programList.$focusItem.data.value &&
                                        $nowDate.innerText !== utils.getCurrentDate(programList.$focusItem.data.value.start * 1000) ) {
                                        $nowDate.innerText = utils.getCurrentDate(programList.$focusItem.data.value.start * 1000);
                                    }
                                    initFooterOnEpgSelect();
                                    break;
                                case keys.down:
                                    next = programList.data[current.index + 1];
                                    if ( next && next.value ) {
                                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                                    } else if ( next && !next.value && programList.data[current.index + 2] ) {
                                        programList.focusIndex(current.index + 2);
                                    }
                                    initFooterOnEpgSelect();
                                    if ( programList.$focusItem && programList.$focusItem.data.value &&
                                        $nowDate.innerText !== utils.getCurrentDate(programList.$focusItem.data.value.start * 1000) ) {
                                        $nowDate.innerText = utils.getCurrentDate(programList.$focusItem.data.value.start * 1000);
                                    }
                                    break;
                                default:
                                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                                    break;
                            }

                            keydownHandlerForOsdInput(event);
                        },
                        'click:item': function ( event ) {
                            var epg;

                            if ( event && event.$item && event.$item.value ) {
                                epg = event.$item.value;

                                if ( epg.archive ) {
                                    // play epg
                                    sendEpgPlayIntent(channelList.$focusItem.index, epg);
                                } else if ( epg.channel.local_pvr || epg.channel.pvr ) {
                                    sendRecordEpgIntent();
                                }

                            }
                        }
                    }
                })
            ],
            events: {
                focus: function ( event ) {
                    Panel.prototype.defaultEvents.focus.call(this, event);
                    initFooterOnEpgSelect();
                }
            }
        })
    ]
);

mainSet = new PanelSet({
    panels: appUIPanels
});

page.add(mainSet);
//mainSet.drawShadow();

channelPanel.$body.appendChild(scrollbars.channelList.$node);
categoryList.$body.appendChild(scrollbars.categoryList.$node);
epgPanel.$body.appendChild(scrollbars.epg.$node);
programList.$noData.classList.add('disabled');
channelPanel.add(channelList = new LayoutList({
    size: 7,
    focusIndex: 0,
    cycle: true,
    noData: gettext('No channels'),
    data: [],
    render: require('../modules/channel.list.item.render'),
    fixedData: true,
    className: 'channelList',
    scroll: scrollbars.channelList,
    events: {
        keydown: function ( event ) {
            var nowTime = utils.getCurrentDate(),
                self = this;

            if ( keyblock ) {
                return;
            }

            LayoutList.prototype.defaultEvents.keydown.call(this, event);
            switch ( event.code ) {
                case keys.up:
                case keys.down:
                    if ( $nowDate.innerText !== nowTime ) {
                        $nowDate.innerText = nowTime;
                    }
                    initFooterOnChannelSelect();
                    clearTimeout(tv.epgTimeout);
                    if ( !self.$focusItem ) { return; }
                    tv.epgTimeout = setTimeout(function () {
                        if ( !self.$focusItem ) { return; }
                        tv.list[self.$focusItem.index].getEpg(null, function ( error, data ) {
                            renderEpgList(error, data);
                            if ( app.activePage.activeComponent === programList ) {
                                /// update footer if we go to program list
                                initFooterOnEpgSelect();
                            }
                        });
                    }, 800);
                    break;
                case keys.menu:
                    /*mainSet.blur();
                    renderActionModal();
                    channelActionModal.show();*/
                    break;
            }

            keydownHandlerForOsdInput(event);
        },
        'click:item': function ( event ) {
            setChannel(event.$item.index, {compareState: true, silent: NEED_SILENCE});
        },
        'focus:item': function () {
            if ( mainSet.focusIndex === 1 ) {
                initFooterOnChannelSelect();
            }
        },
        'move:view': updateChannelListEpg
    }
}));

// if ( DEVELOP ) {
//     window.channelList = channelList;
// }

page.add(
    channelActionModal = new ModalMessage({
        title: gettext('Actions'),
        className: 'width2x',
        events: {
            show: function () {
                this.focus();
                this.children[0].focus();
                footer.hide();
            },
            hide: function () {
                channelPanel.focus();
                footer.show();
            }
        },
        children: [
            actionModalList = new LayoutList({
                className: 'actionsModal',
                size: 2,
                cycle: true,
                focusIndex: 0,
                data: [
                    {
                        items: makeItem(iconList.record, gettext('Record')),
                        click: function () {
                            sendRecordIntent();
                            channelActionModal.hide();
                        }
                    },
                    {
                        items: makeItem('theme-icon theme-icon-rc-f2', antennaEnable ? gettext('Antenna power off') : gettext('Antenna power on')),
                        click: function () {
                            antennaPower();
                            channelActionModal.hide();
                        }
                    },
                    {
                        items: makeItem(iconList.favorite, gettext('Favorite')),
                        click: function () {
                            toggleFavorite({index: channelList.$focusItem.index, item: channelList.$focusItem},
                                function () { channelActionModal.hide(); });
                        }
                    },
                    {
                        items: makeItem(iconList.tvGuide, gettext('TV guide')),
                        click: function () {
                            app.route(app.pages.epg, channelList.$focusItem);
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                channelActionModal.hide();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    }),
    epgMenu = new ModalMessage({
        title: gettext('Actions'),
        events: {
            show: function () {
                this.focus();
                this.children[0].focus();
                footer.hide();
            },
            hide: function () {
                programList.focus();
                footer.show();
            }
        },
        children: [
            new LayoutList({
                data: [],
                size: 1,
                cycle: true,
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                epgMenu.hide();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    }),
    exitModal = new ModalMessage({
        title: gettext('Exit'),
        events: {
            show: function () {
                this.focus();
                this.children[0].focus();
                footer.hide();
            },
            hide: function () {
                mainSet.focus();
                footer.show();
            }
        },
        children: [
            new LayoutList({
                className: 'padded',
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                value: gettext('Yes')
                            }
                        ],
                        click: function () {
                            // exit
                            exitModal.hide();
                            app.exit();
                        }
                    },
                    {
                        items: [
                            {
                                value: gettext('No')
                            }
                        ],
                        click: function () {
                            exitModal.hide();
                        }
                    }
                ],
                size: 2,
                cycle: true,
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                exitModal.hide();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    }),
    resetModal = new ModalMessage({
        title: gettext('Actions'),
        events: {
            show: function () {
                this.children[0].focus();
                footer.hide();
            },
            hide: function () {
                mainSet.focus();
                footer.show();
            }
        },
        children: [
            new LayoutList({
                focusIndex: 0,
                data: [
                    {
                        items: makeItem('theme-icon theme-icon-rc-f1', gettext('Reset filters')),
                        click: function () {
                            //reset filters
                            resetFilters();
                            resetModal.hide();
                        }
                    }
                ],
                size: 1,
                cycle: true,
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.back:
                            case keys.menu:
                                resetModal.hide();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    })
);


function prepareChannels ( data ) {
    var index,
        channel,
        result = [],
        titleWrap,
        title,
        epgName,
        epg;

    if ( !data || data.length < 1 ) {
        return [];
    }

    for ( index = 0; index < data.length; index++ ) {
        titleWrap = document.createElement('div');
        title = document.createElement('div');
        title.className = 'name';
        epg = document.createElement('div');
        epg.className = 'epg' + (data[index].currentEpg ? ' visible' : '');
        title.innerText = data[index].name;
        if ( data[index].currentEpg && data[index].currentEpg.title ) {
            epg.innerText = data[index].currentEpg.title;
            epgName = data[index].currentEpg.title;
        } else {
            epg.innerText = '';
            epgName = '';
        }

        titleWrap.appendChild(title);
        titleWrap.appendChild(epg);
        channel = {
            items: [
                {
                    className: 'number' + (data[index]['monitoring_status'] ? '' : ' monitoringFail'),
                    value: data[index].number.toString()
                }
            ],
            value: data[index]
        };


        channel.items = channel.items.concat([
            {
                className: 'title' + (data[index]['monitoring_status'] ? '' : ' monitoringFail'),
                value: titleWrap,
                htmlInstance: true,
                realValue: {name: data[index].name, epg: epgName}
            },
            {
                className: ((data[index].censored || data[index].genre.censored ) ? 'theme-icon theme-icon-lock disabled' : '')
            },
            {
                className: ((data[index].archive || data[index].local_timeshift ) ? 'theme-icon theme-icon-timeshift disabled' : '')
            },
            {
                className: (data[index].favorite ? 'theme-icon theme-icon-favorite-active active' : '')
            }
        ]);

        result.push(channel);
    }

    return result;
}


page.addListener('show', function ( data ) {
    channelPanel.focus();
    if ( data && data.data ) {
        channelList.focusIndex(data.data.index);
    }
});

page.addListener('keydown', function ( event ) {
    if ( keyblock ) {
        return;
    }

    switch ( event.code ) {
        case keys.back:
            //setChannel(tv.currentIndex, {context:null});
            returnToPlayer();
            break;
        case keys.exit:
            if ( app.lastIntent ) {
                app.lastIntent.emit('exit');
            }

            // hack to set that app is minimized
            app.minimized = true;
            break;
        case keys.web:
            // hack to set that app is minimized
            app.minimized = true;
            break;
        case keys.channelNext:
            // nextChannelCallback({osd: false, skipCensored: false});
            break;
        case keys.channelPrev:
            // prevChannelCallback({osd: false, skipCensored: false});
            break;
    }
});

startApp();


function updateChannelList ( callback ) {
    provider.getChannels(tv.config, function ( error, data ) {
    // render new list
        if ( !error  ) {
            channelList.setData({
                data: prepareChannels(data),
                focusIndex: 0
            });

            tv.list = data;
            $channelsCount.innerText = data.length;

            setTimeout(function () {
                app.pages.epg.setChannels(data);
                // app.emit('channels:load', data);
            }, 0);

            if ( callback ) {
                callback();
            }

            if ( channelList.$focusItem ) {
                channelList.$focusItem.data.value.getEpg(null, renderEpgList);
            } else {
                renderEpgList(false, []);
            }
        } else {
            console.log('error getting channels');
        }
    });
}


function nextChannelCallback ( config ) {
    var index = ++tv.currentIndex,
        skipCensored = true,
        showOsd = true;

    config = config || {};

    if ( config.osd !== undefined ) {
        showOsd = config.osd;
    }

    if ( config.skipCensored !== undefined ) {
        skipCensored = config.skipCensored;
    }

    if ( index > tv.list.length - 1 ) {
        index = 0;
        tv.currentIndex = 0;
    }

    // skip censored channel in fullscreen mode
    if ( skipCensored && (tv.list[index].censored || ( tv.list[index].genre && tv.list[index].genre.censored )) ) {
        nextChannelCallback();

        return;
    }
    setChannel(index, {osd: showOsd});
}


function prevChannelCallback ( config ) {
    var index = --tv.currentIndex,
        skipCensored = true,
        showOsd = true;

    config = config || {};

    if ( config.osd !== undefined ) {
        showOsd = config.osd;
    }

    if ( config.skipCensored !== undefined ) {
        skipCensored = config.skipCensored;
    }
    if ( index < 0 ) {
        index = tv.currentIndex = tv.list.length - 1;
    }

    // skip censored channel in fullscreen mode
    if ( skipCensored && (tv.list[index].censored || ( tv.list[index].genre && tv.list[index].genre.censored )) ) {
        prevChannelCallback(config);
    } else {
        setChannel(index, {osd: showOsd});
    }
}


/**
 * Send intent to record channel
 */
function sendRecordIntent () {
    var channel;

    if ( !channelList.$focusItem.data.value.pvr && !channelList.$focusItem.data.value.local_pvr ) {
        return;
    }

    channel = channelList.$focusItem.data.value;

    if ( (channel.censored || ( channel.genre && channel.genre.censored )) &&
        ( core.accessControl && !core.accessControl.state ) ) {

        // close existing intents on osd
        closeOpenedIntents([app.intents.osdInput, app.intents.osdTv]);
        app.intents.osdInput = app.intents.osdTv = null;

        core.accessControl.request(function ( error ) {
            if ( !error ) {
                core.intent({
                    action: 'record',
                    data: {
                        uri: channel.url,
                        name: channel.name,
                        id: channel.id,
                        pvr: {
                            server: channel.pvr,
                            local:  channel.local_pvr
                        }
                    }
                });
            }
        });
    } else {
        core.intent({
            action: 'record',
            data: {
                uri: channel.url,
                name: channel.name,
                id: channel.id,
                pvr: {
                    server: channel.pvr,
                    local: channel.local_pvr
                }
            }
        });
    }
}

/**
 * Send intent ro record epg program
 */
function sendRecordEpgIntent () {
    var channel = channelList.$focusItem.data.value,
        epg = programList.$focusItem.data.value;

    app.foreground = false;

    core.intent({
        action: 'record',
        data: {
            uri: channel.url,
            name: channel.name,
            epgName: channel.name,
            startTime: epg.start,
            endTime: epg.end,
            id: channel.id,
            pvr: {
                server: channel.pvr,
                local:  channel.local_pvr
            }
        }
    });
}

function antennaPower () {
    app.provider.antennaPower = !antennaEnable;
}

/**
 * Send intent to show osd-input.
 *
 * @param {number} startCode - startCode to init intent
 * @param {boolean} osdState - osdState to show osd-tv
 * @param {boolean} compareState - compareState to call compare tv list config or not
 */
function sendOsdInputIntent ( startCode, osdState, compareState ) {
    keyblock = true;
    clearTimeout(keyblockRevertTimeout);
    keyblockRevertTimeout = setTimeout(function () {
        keyblock = false;
    }, KEYBLOCK_REVERT_TIMOUT);

    app.intents.osdInput = core.intent({
        action: 'osd-input',
        data: {
            type: 'numbers',
            length: 4,
            startChar: startCode
        },
        events: {
            done: function ( value ) {
                var channel,
                    focusIndex,
                    index;

                if ( value && tv.current && tv.current.number && tv.current.number === Number(value) ) {
                    // the same channel
                    return;
                }

                // check in current list
                for ( index = 0; index < tv.list.length; index++ ) {
                    channel = tv.list[index];
                    if ( channel.number === Number(value) ) {
                        focusIndex = index;
                        break;
                    }
                }

                if ( focusIndex !== undefined ) {
                    channelList.focusIndex(focusIndex);
                    setChannel(focusIndex, {osd: osdState, silent: true, compareState: compareState});
                    channelList.$focusItem.data.value.getEpg(null, function ( error, data ) {
                        renderEpgList(error, data);
                        initFooterOnEpgSelect();
                    });
                } else {
                    core.notify({
                        title: gettext('No such channel number'),
                        icon: 'alert',
                        type: 'warning',
                        timeout: 1000
                    });
                }

                keyblock = false;
            }
        }
    });
}


function sendEpgPlayIntent ( channelIndex, epgObject ) {
    var  channel = tv.list[channelIndex];

    channelList.focusIndex(channelIndex);

    if ( DEVELOP ) {
        console.log(channel, 'chan');
        console.log(epgObject, 'epgObj');
    }

    channel.getEpg(null, function (error, data) {
        var index,
            epgIndex,
            focusIndex;

        renderEpgList(error, data);
        if ( DEVELOP ) {
            console.log(error, 'error');
        }

        if ( data.length ) {
            for ( index = 0; index < tv.epg.list.length; index++ ) {
                if ( tv.epg.list[index].id === epgObject.id ) {
                    epgIndex = index;
                }
            }

            for ( focusIndex = 0; focusIndex < programList.data.length; focusIndex++ ) {
                if ( programList.data[focusIndex] && programList.data[focusIndex].value &&
                    programList.data[focusIndex].value.id && programList.data[focusIndex].value.id === epgObject.id ) {
                    programList.focusIndex(focusIndex);
                }
            }

            if ( epgIndex ) {
                tv.epg.currentPlayIndex = epgIndex;

                tv.epg.currentPlayIndex = epgIndex;
                epgObject.getLink(function ( error, epgData ) {
                    var nextHandler,
                        prevHandler;

                    if ( error ) {
                        console.log(error);
                    }

                    if ( epgData && epgData.url ) {
                        if ( tv.epg.list[tv.epg.currentPlayIndex - 1]
                            && tv.epg.list[tv.epg.currentPlayIndex - 1].archive ) {
                            prevHandler = function () {
                                programList.emit('keydown', {code: keys.up});
                                sendEpgPlayIntent(channelIndex, tv.epg.list[--tv.epg.currentPlayIndex]);
                            };
                        }

                        if (  tv.epg.list[tv.epg.currentPlayIndex + 1] &&
                            tv.epg.list[tv.epg.currentPlayIndex + 1].archive ) {
                            nextHandler = function () {
                                programList.emit('keydown', {code: keys.down});
                                sendEpgPlayIntent(channelIndex, tv.epg.list[++tv.epg.currentPlayIndex]);
                            };
                        } else {
                            nextHandler = function () {
                                setChannel(channelIndex, {force: true});
                            };
                        }

                        tv.current = null;
                        app.lastIntent = core.intent({
                            action: 'play',
                            mime: 'content/video',
                            context: null,
                            data: {
                                uri: epgData.url,
                                solution: epgData.solution,
                                resource: 'tv-archive',
                                title: epgObject.title,
                                persistent: true,
                                mediaId: epgData['media_id'],
                                exitWithConfirm: true
                            },
                            events: {
                                close: function () {
                                    // clear context to show player after new channel select
                                    tv.context = null;
                                    // app.foreground = true;
                                    // need to hide osd-tv if player intent is closed
                                    if ( app.intents.osdTv ) {
                                        app.intents.osdTv.close();
                                        app.intents.osdTv = null;
                                    }
                                },
                                next: nextHandler,
                                prev: prevHandler,
                                nextChannel: nextChannelCallback,
                                prevChannel: prevChannelCallback,
                                stop: function ( event ) {
                                    event = event || {};

                                    if ( event.manual ) {
                                        // playChannel
                                        setChannel(channelIndex, {
                                            force: true
                                        });
                                    }
                                },
                                onPip: function () {
                                    NEED_SILENCE = true;
                                    tv.context = null;
                                    tv.current = null;
                                    tv.currentIndex = null;
                                },
                                end: nextHandler
                            }
                        }, function ( error, context ) {
                            if ( error ) {
                                console.log(error);
                            }

                            tv.context = context;
                            tv.currentIndex = channelIndex;
                            tv.current = tv.list[channelIndex];
                        });

                    } else {
                        // notify if can't get epg link
                        notifyError(gettext('Error getting EPG'));
                    }
                });
            } else {
                // notify error here. we cant find index of program
                notifyError(gettext('Error getting EPG'));
            }
        } else {
            // notify error here
            notifyError(gettext('Error getting EPG for ') + channel.name);
        }
    });
}


// app.sendEpgPlayIntent = sendEpgPlayIntent;

/**
 * Init footer when select epg program
 */
function initFooterOnEpgSelect () {
    var nowTime = new Date() / 1000;

    if ( page.activeComponent !== programList ) {
        return;
    }

    if ( !programList.$focusItem || (programList.$focusItem && !programList.$focusItem.data.value ) ) {
        // updateFooterLater([]);
        footer.hide();

        return;
    }

    if ( programList.$focusItem.data.value.archive ) {
        updateFooterLater(
            {
                left: {
                    code: keys.menu,
                    action: showEpgMenu
                },
                middle: [
                    {
                        title: gettext('Play'),
                        code: keys.f2,
                        action: function () {
                            sendEpgPlayIntent(channelList.$focusItem.index, programList.$focusItem.data.value);
                        }
                    }
                ],
                label: {
                    code: keys.menu,
                    title: gettext('Hold OK button to open Options menu'),
                    action: showEpgMenu
                }
            }
            /*[
            {code: keys.menu, action: showEpgMenu},
            {
                title: _('Play'),
                code: keys.f2,
                action: function () {
                    sendEpgPlayIntent(channelList.$focusItem.index, programList.$focusItem.data.value);
                }
            }]*/);
        //footer.show();
    } else {
        if ( (programList.$focusItem.data.value.start > nowTime ||
            ( programList.$focusItem.data.value.start < nowTime && programList.$focusItem.data.value.end > nowTime )) &&
            channelList.$focusItem && channelList.$focusItem.data && channelList.$focusItem.value &&
            ( channelList.$focusItem.data.value.pvr || channelList.$focusItem.data.value.local_pvr ) ) {
            updateFooterLater(
                {
                    left: {
                        code: keys.menu,
                        action: showEpgMenu
                    },
                    middle: [
                        {
                            title: gettext('Record'),
                            code: keys.f1,
                            action: function () {
                                if ( !programList.$focusItem ) {
                                    return;
                                }
                                sendRecordEpgIntent();
                            }
                        }
                    ],
                    label: {
                        code: keys.menu,
                        title: gettext('Hold OK button to open Options menu'),
                        action: showEpgMenu
                    }
                }
            );
        } else {
            footer.hide();
        }
    }
}

function initFooterOnChannelSelect () {
    var initData = {
        left: {
            code: keys.menu,
            action: function () {
                mainSet.blur();
                renderActionModal();
                channelActionModal.show();
            }
        },
        middle: [],
        label: {
            code: keys.menu,
            title: gettext('Hold OK button to open Options menu'),
            action: function () {
                mainSet.blur();
                renderActionModal();
                channelActionModal.show();
            }
        }
    };

    if ( channelList.$focusItem ) {
        if ( channelList.$focusItem.data.value.pvr || channelList.$focusItem.data.value.local_pvr ) {
            initData.middle.push(
                {
                    code: keys.f1,
                    title: gettext('Record'),
                    action: function () {
                        sendRecordIntent();
                    }
                }
            );
        }
    }

    if ( TARGET === 'dvb' ) {
        initData.middle.push(
            {
                code: keys.f2,
                title: antennaEnable ? gettext('Antenna power off') : gettext('Antenna power on'),
                action: function () {
                    antennaPower();
                }
            }
        );
    }

    if ( channelList.$focusItem ) {
        initData.middle.push(
            {
                code: keys.f3,
                title: gettext('Favorite'),
                action: function () {
                    toggleFavorite({index: channelList.$focusItem.index, item: channelList.$focusItem},
                        function () { debug.log('toggle favorite'); });
                }
            }
        );

        initData.middle.push({
            code: keys.f4,
            title: gettext('TV guide'),
            action: function () {
                app.route(app.pages.epg, channelList.$focusItem);
            }
        });
    }

    updateFooterLater(initData);
}


/**
 * Show epg menu modal message
 */
function showEpgMenu () {
    var list = epgMenu.children[0],
        currentEpg,
        nowTime = new Date() / 1000,
        renderData = [];

    if ( programList.$focusItem ) {
        currentEpg = programList.$focusItem.data.value;
    } else {
        return;
    }

    if ( currentEpg.archive ) {
        renderData[0] = {
            items: makeItem(iconList.play, gettext('Play')),
            click: function () {
                sendEpgPlayIntent(channelList.$focusItem.index, programList.$focusItem.data.value);
                epgMenu.hide();
            }
        };
    } else if ( (currentEpg.start > nowTime || ( currentEpg.start < nowTime && currentEpg.end > nowTime ))
        && (channelList.$focusItem.data.value.pvr || channelList.$focusItem.data.value.local_pvr) ) {
        renderData[0] = {
            items: makeItem(iconList.record, gettext('Record')),
            click: function () {
                sendRecordEpgIntent();
                epgMenu.hide();
            }
        };
    } else { return; }

    list.init({
        data: renderData,
        size: renderData.length,
        focusIndex: 0
    });
    epgMenu.show();
}

if ( DEVELOP ) {
    window.tv = tv;
}


/**
 * Base function to start app, get last channel or get channel list
 */
function startApp () {
    var categories = [],
        isHome = core.applicationState.home;

    $nowDate.innerText = utils.getCurrentDate();
    $nowDate.style.height = window.getComputedStyle($nowDate).height;

    provider.updateChannelsList(function ( error ) {
        if ( error ) {
            // do smth
        }

        provider.getLastChannelId(function ( error, id ) {
            var index, channel, focusIndex;

            setTimeout(function () {
                console.log('TV APP START');
                app.ready();
                app.loaded = true;
                app.emit('ready');
                if ( provider.startBackgroundCheck ) {
                    provider.startBackgroundCheck();
                }
            }, 100);

            if ( error && !id ) {
                updateChannelList(function () {
                    if ( channelList.$focusItem ) {
                        //setChannel(channelList.$focusItem.index, {silent: true});
                    }
                });
            } else {
                updateChannelList(function () {
                    for ( index = 0; index < tv.list.length; index++ ) {
                        channel = tv.list[index];
                        if ( channel.id === Number(id) ) {
                            focusIndex = index;
                            break;
                        }
                    }

                    focusIndex = focusIndex || 0;
                    if ( tv.list.length === 0 ) {
                        return;
                    }

                    channelList.focusIndex(focusIndex);

                    if (
                        channelList.$focusItem.data.value
                        && ( channelList.$focusItem.data.value.censored
                        || (channelList.$focusItem.data.value.genre && channelList.$focusItem.data.value.genre.censored))
                    ) {
                        // channel is under parrent password, need to do something
                        console.log('channel is censored');
                    } else {
                        core.once('show', function () {
                            if ( core.applicationState.visible ) {
                                if ( isHome ) {
                                    setChannel(focusIndex, {silent: false, context: null});
                                } else {
                                    setChannel(focusIndex, {silent: false});
                                }
                            }
                        });
                    }
                });
            }
        });
    });

    // get and generate category list :)
    if ( MODE === 'MINISTRA' && TARGET !== 'dvb' ) {
        categories[0] = {
            items: [
                {
                    value: gettext('All categories'),
                    className: 'title'
                }
            ],
            value: {id: false, name: gettext('All categories')}
        };

        provider.getCategories(function ( error, data ) {
            if ( !error ) {
                data.forEach(function (genre) {
                    categories.push({
                        items: [
                            {
                                value: genre.name,
                                className: 'title'
                            }
                        ],
                        value: genre
                    });
                });
            }
            categoryList.children[0].init({
                data: categories,
                focusIndex: 0
            });
        });
    }

    provider.addListener('channels:delete', deleteChannelsCallback);
    provider.addListener('channels:add', addChannelsCallback);
    provider.addListener('channels:modified', updateChannelsCallback);
    provider.addListener('update', fullUpdateChannelsCallback);
}

// Callback on 'channels:delete' event
function deleteChannelsCallback ( event ) {
    core.notify({
        title: format(window.ngettext('{0} channel was deleted', '{0} channels were deleted', event.data.length), event.data.length),
        icon: 'alert',
        type: 'warning',
        timeout: CHANNELS_UPDATE_NOTIFICATION_TIMEOUT
    });
    updateRender();
}

// Callback on 'channels:add' event
function addChannelsCallback ( event ) {
    console.log('Add Channels');

    if (event.data.length > 1 ) {
        core.notify({
            title: format(gettext('{0} channels were added'), event.data.length),
            icon: 'info',
            type: 'success',
            timeout: CHANNELS_UPDATE_NOTIFICATION_TIMEOUT
        });
    } else if ( event.data.length === 1 ) {
        core.notify({
            title:  format(gettext('Channel {0} was added'), event.data[0].name),
            icon: 'info',
            type: 'success',
            timeout: CHANNELS_UPDATE_NOTIFICATION_TIMEOUT
        });
    }

    updateRender();
}

/**
 * Full update channel list if get message from server
 */
function fullUpdateChannelsCallback () {
    console.log('Channels were updated____');

    // notify only if app is visible
    if ( core.applicationState.visible ) {
        core.notify({
            title: gettext('Channels were updated'),
            icon: 'info',
            type: 'success',
            timeout: CHANNELS_UPDATE_NOTIFICATION_TIMEOUT
        });
    }
    updateRender();
}

/**
 * Callback on channels:modified event
 *
 */
function updateChannelsCallback () {
    provider.getChannels(tv.config, function ( error, data ) {
        var index;

        if ( error ) {
            console.log(error);
        }

        tv.list = data;
        channelList.data = prepareChannels(data);
        for ( index = 0; index < channelList.$body.children.length; index++ ) {
            channelList.renderItem(channelList.$body.children[index], channelList.data[channelList.$body.children[index].index]);
        }
    });
}

/**
 * Rerender channel list after callbacks
 */
function updateRender () {
    provider.getChannels(tv.config, function (error, data) {
        var focusId = channelList.$focusItem.data.value.id,
            index, newIndex,
            newFocusIndex;

        if ( error ) {
            console.log(error);
        }

        channelList.setData({
            data: prepareChannels(data),
            focusIndex: 0
        });
        tv.list = data;
        $channelsCount.innerText = data.length;
        app.pages.epg.setChannels(data);
        // app.emit('channels:load', data);
        if ( tv.current && tv.current.id ) {
            for ( index = 0; index < tv.list.length; index++ ) {
                if ( tv.list[index].id === tv.current.id ) {
                    newIndex = index;
                    break;
                }
            }
        }

        for ( index = 0; index < tv.list.length; index++ ) {
            if ( tv.list[index].id === focusId ) {
                newFocusIndex = index;
                break;
            }
        }

        newIndex = newIndex || 0;
        newFocusIndex = newFocusIndex || 0;

        tv.currentIndex = newIndex;
        channelList.focusIndex(newFocusIndex);

        tv.list[channelList.$focusItem.index].getEpg(null, renderEpgList);
    });
}

function updateChannelListEpg () {
    clearTimeout(tv.channelListEpgTimeout);
    tv.channelListEpgTimeout = setTimeout(update, core.environment.onFocusDebounceTimeout || 400);

    clearInterval(tv.channelListEpgInterval);
    tv.channelListEpgInterval = setInterval(update, CURRENT_EPG_UPDATE_INTERVAL);

    function update () {
        var index,
            channelArray = [];

        for ( index = 0; index < channelList.$body.children.length; index++ ) {
            if ( channelList.$body.children[index].data ) {
                channelArray.push(channelList.$body.children[index].data.value);
            }
        }
        provider.getChannelsEpg({channels: channelArray}, function ( error, data ) {
            var channel;

            if ( !error ) {
                for ( index = 0; index < channelList.$body.children.length; index++ ) {
                    if ( channelList.$body.children[index].data ) {
                        channel = channelList.$body.children[index].data.value;
                    }

                    if ( channel && data[channel.id] ) {
                        channel.currentEpg = data[channel.id][0];
                    }
                }
                channelList.data = prepareChannels(tv.list);

                for ( index = 0; index < channelList.$body.children.length; index++ ) {
                    if (channelList.$body.children[index].data) {
                        channelList.renderItem(channelList.$body.children[index], channelList.data[channelList.$body.children[index].index]);
                    }
                }
            }
        });
    }
}


/**
 * Render EPG list.
 *
 * @param {boolean} error - error state
 * @param {Array} data - data of epg programs
 */
function renderEpgList ( error, data ) { // eslint-disable-line
    var time = '',
        stateClassName = '',
        renderData = [],
        nowTime = new Date() / 1000,
        prog, config, index, timeIconClassName,
        channel,
        currentIndex,
        viewIndex;

    if ( error ) {
        console.log(error);
    }

    if ( !channelList.$focusItem ) {
        $nowDate.innerText = utils.getCurrentDate();

        return;
    }

    tv.epg.list = data;
    channel = channelList.$focusItem.data.value;

    if ( channel && ( channel.censored || (channel.genre && channel.genre.censored)) && ( !tv.current || tv.current.id !== channel.id ) &&
        (core.accessControl && !core.accessControl.state) ) {
        // hide epg if channel in under parent control and nor current
        programList.init({data: []});
        programList.$noData.classList.remove('disabled');

        return;
    }

    programList.$noData.classList.add('disabled');

    // insert date items
    data = insertDays(data);
    for ( index = 0; index < data.length; index++ ) {
        prog = data[index];
        timeIconClassName = 'time';
        // this is realy epg program
        if ( prog.systemDate ) {
            renderData.push({
                items: [
                    {
                        value: prog.title,
                        className: 'system-date'
                    }
                ],
                value: null
            });
        } else {
            if ( prog.start ) {
                time = new Date(prog.start * 1000);
                time = ( '0' + time.getHours()).slice(-2) + ':' + ( '0' + time.getMinutes()).slice(-2);
            }

            if ( prog.archive) {
                timeIconClassName += ' green';
            } else if ((channelList.$focusItem.data.value.pvr || channelList.$focusItem.data.value.local_pvr) &&
                (prog.start > nowTime || ( prog.start < nowTime && prog.end > nowTime )) ) {
                timeIconClassName += ' red';
            }
            if ( prog.end < nowTime ) {
                stateClassName = ' theme-text-disabled';
            } else if ( prog.start < nowTime && prog.end > nowTime ) {
                stateClassName = ' current';
            } else {
                stateClassName = ' coming';
            }
            renderData.push({
                items: [
                    {className: timeIconClassName + stateClassName, value: time},
                    {className: 'title' + stateClassName, value: prog.title}
                ],
                value: prog
            });
        }
    }

    config = {
        data: renderData,
        size: 7
    };

    if ( data.length ) {
        config.focusIndex = 0;
    }

    programList.init(config);

    viewIndex =  data.findIndex(function ( object ) {
        return (!object.systemDate && object.start < nowTime && object.end > nowTime);
    });

    if ( viewIndex && viewIndex > 6 ) {
        if ( data.length - viewIndex - 4 > 0 ) {
            programList.renderView(viewIndex - 3);
        } else {
            programList.renderView(data.length - 7);
        }
    }

    currentIndex = programList.data.findIndex(function ( program ) {
        return (program.value && program.value.start < nowTime && program.value.end > nowTime);
    });

    if ( currentIndex && currentIndex > 0 ) {
        programList.focusIndex(currentIndex);
    } else {
        if ( programList.$focusItem && !programList.$focusItem.data.value ) {
            if ( programList.data[programList.$focusItem.index + 1] ) {
                programList.focusIndex(programList.$focusItem.index + 1);
            } else if ( programList.data[programList.$focusItem.index - 1] ) {
                programList.focusIndex(programList.$focusItem.index - 1);
            }
        }
    }

    if ( programList.$focusItem && programList.$focusItem.data.value &&
        $nowDate.innerText !== utils.getCurrentDate(programList.$focusItem.data.value.start * 1000) ) {
        $nowDate.innerText = utils.getCurrentDate(programList.$focusItem.data.value.start * 1000);
    }
}

function insertDays ( data ) {
    var length = data.length,
        result = [],
        current,
        next,
        index;

    if ( !data || length === 0 ) {
        return [];
    }

    result.push({
        systemDate: true,
        title: utils.getCurrentDate(data[0].start * 1000)
    });

    for ( index = 0; index < length - 1; index++ ) {
        current = data[index];
        next = data[index + 1];
        result.push(current);

        // check if next epg program has biggest start date
        if ( new Date(current.start * 1000).getDate() < new Date(next.start * 1000).getDate() ||
             new Date(current.start * 1000).getMonth() < new Date(next.start * 1000).getMonth() ) {
            result.push({
                systemDate: true,
                title: utils.getCurrentDate(next.start * 1000)
            });
        }
    }

    result.push(data[length - 1]);

    return result;
}

/**
 * Render channel action modal menu
 */
function renderActionModal () {
    var data = [],
        channel = channelList.$focusItem.data.value;

    if ( channelList.$focusItem && (channelList.$focusItem.data.value.pvr || channelList.$focusItem.data.value.local_pvr ) ) {
        data.push({
            items: makeItem(iconList.record, gettext('Record')),
            click: function () {
                sendRecordIntent();
                channelActionModal.hide();
            }
        });
    }

    if ( TARGET === 'dvb' ) {
        data.push({
            items: makeItem('theme-icon theme-icon-rc-f2', antennaEnable ? gettext('Antenna power off') : gettext('Antenna power on')),
            click: function () {
                antennaPower();
                channelActionModal.hide();
            }
        });
    }

    if ( channel.favorite ) {
        data.push({
            items: makeItem(iconList.favoriteActive, gettext('Remove from favorites')),
            click: function () {
                toggleFavorite({index: channelList.$focusItem.index, item: channelList.$focusItem},
                    function () {
                        channelActionModal.hide();
                    });
            }
        });
    } else {
        data.push({
            items: makeItem(iconList.favorite, gettext('Add to favorite')),
            click: function () {
                toggleFavorite({index: channelList.$focusItem.index, item: channelList.$focusItem},
                    function () {
                        channelActionModal.hide();
                    });
            }
        });
    }

    data.push({
        items: makeItem(iconList.tvGuide, gettext('TV guide')),
        click: function () {
            channelActionModal.hide();
            setTimeout(function () {
                app.route(app.pages.epg, channelList.$focusItem);
            });
        }
    });

    if ( !provider.local ) {
        // add some actions for local channels storage
        data = data.concat([]);
    }

    actionModalList.init({
        data: data,
        size: data.length > 5 ? 5 : data.length,
        focusIndex: 0
    });
}


function toggleFavorite ( config, callback ) {
    var index = config.index;

    tv.list[index].toggleFavorite(function ( error, state ) {
        // rerender list or element if no error
        if ( !error ) {
            channelList.data[index].value.favorite = state;
            if ( state ) {
                channelList.data[index].items[4].className = 'icon theme-icon-favorite-active active';
            } else {
                channelList.data[index].items[4].className = 'icon theme-icon-favorite disabled';
            }
            if ( config.item ) {
                channelList.renderItem(config.item, prepareChannels([tv.list[index]])[0]);
            }

            // set current channel state if needed
            if ( tv.current && tv.current.id === tv.list[index].id ) {
                titleWidget.set(tv.list[index]);
            }
        } else {
            return;
        }

        if ( callback ) {
            callback();
        }
    });
}


/**
 * Reset selected filters and update channel list.
 *
 * @param {Object} [config] - config object to set filters
 * @param {boolean} [resetLastConfig] - reset last config flag to reset previous played config
 * @param {Function} [callback] - callback after reset
 */
function resetFilters ( config, resetLastConfig, callback ) {
    var favoriteIco  = menuList.$body.children[1].children[0].children[0],
        categoryItem = menuList.$body.children[2].children[0].children[1],
        categoryIcon = menuList.$body.children[2].children[0].children[0],
        searchItem   = menuList.$body.children[0].children[0].children[1],
        searchIcon   = menuList.$body.children[0].children[0].children[0],
        genreIndex;

    config = config || {};

    if ( !tv.config.search && !tv.config.favorite && !tv.config.genre && !Object.keys(config).length ) {
        return;
    }

    console.log('RESET FILTERS');
    console.log(config);
    if ( config.favorite ) {
        // $item.layout.$body.childNodes[0].className = 'theme-icon theme-icon-favorite-active active';
        favoriteIco.className = 'theme-icon theme-icon-favorite-active active';
    } else {
        favoriteIco.className = 'theme-icon theme-icon-favorite';
    }
    tv.config.favorite = config.favorite || false;

    searchItem.innerText = config.search || gettext('Search');
    tv.config.search = config.search || false;
    if ( !tv.config.search ) {
        searchIcon.classList.remove('active');
    } else {
        searchIcon.classList.add('active');
    }

    if ( TARGET !== 'dvb' ) {
        if ( config.genre !== undefined ) {
            genreIndex = categoryModalList.data.findIndex(function ( genre ) { return genre.value.id === config.genre; });
            categoryItem.innerText = categoryModalList.data[genreIndex].value.name;
            tv.config.genre = config.genre;
            categoryModalList.focusIndex(genreIndex);
            if ( config.genre ) {
                categoryIcon.classList.add('active');
            } else {
                categoryIcon.classList.remove('active');
            }
        } else {
            categoryItem.innerText = gettext('All categories');
            categoryIcon.classList.remove('active');
            tv.config.genre = false;
            categoryModalList.focusIndex(0);
        }
    }

    updateChannelList(callback);

    // reset last config and search current channel in total list
    if ( resetLastConfig ) {
        console.log('resetLastConfig');
        tv.lastActiveState.config = {
            favorite: false,
            byName: false,
            genre: false,
            search: false
        };

        channelList.focusIndex(tv.list.indexOf(tv.current));
    }
}

function updateFooterLater ( data, delay ) {
    delay = delay || core.environment.onFocusDebounceTimeout || 400;
    data = data || {middle: []};

    clearTimeout(tv.footerInitDelay);

    tv.footerInitDelay = setTimeout(function () {
        footer.init(data);
        if ( data ) {
            footer.show();
        }
    }, delay);
}

/**
 * Set channel to play.
 *
 * @param {number} index - index of channel to play
 * @param {Object} [config] - config data
 */
function setChannel ( index, config ) {
    var channel;

    config = config || {};
    channel = tv.list[index];

    // show tv-osd if no silent play
    if ( config.osd ) {
        sendOsdTvIntent(channel, false);
    }

    // false to deactivate
    if ( (channel.censored || channel.genre.censored) ) {
        if ( tv.current !== null && channel.id === tv.current.id && !config.force ) {
            process();

            return;
        }

        // close existing osd intents
        closeOpenedIntents([app.intents.osdInput, app.intents.osdTv]);
        app.intents.osdInput = app.intents.osdTv = null;

        core.accessControl.request(function ( error ) {
            debug.warn(error);
            if ( !error ) {
                process({forceEpg: true});
            }
        });
    } else {
        process();
    }

    // need to rename
    function process ( params ) {
        params = params || {};

        if ( channel['monitoring_status'] ) {
            channel.getUrl(function (error, data) {
                if ( error ) {
                    core.notify({
                        title: 'Error getting channel link',
                        icon: 'alert',
                        type: 'warning',
                        timeout: 2000
                    });
                } else {
                    sendIntent(channel, data.url, data.solution );
                }
            });
        } else {
            core.notify({
                title: gettext('Channel is temporary unavailable'),
                icon: 'alert',
                type: 'warning',
                timeout: 2000
            });
        }

        titleWidget.set(channel);

        function sendIntent ( channelToSend, url, solution ) { /*eslint no-else-return:0*/
            var isSame = ( tv.current === channelToSend && !config.force ),
                context,
                modalMenuConfig,
                viewportConfig;

            if ( isSame ) {
                url = '';
            }

            app.foreground = !isSame;


            if ( isSame ) {
                returnToPlayer({force: true});

                return;
            } else {
                context = config.context !== undefined ? config.context : tv.context;
            }

            if ( channelToSend.pvr || channelToSend.local_pvr ) {
                modalMenuConfig = [
                    {
                        icon: 'f1',
                        title: 'Record',
                        handler: function () {
                            channelList.focusIndex(tv.currentIndex);
                            if ( app.intents.osdTv ) {
                                app.intents.osdTv.close();
                                app.intents.osdTv = null;
                            }
                            sendRecordIntent();
                        }
                    }
                ];
            }

            app.lastIntent = core.intent({
                action: 'play',
                mime: 'content/video',
                silent: config.silent,
                data: {
                    uri: url,
                    title: channelToSend.name,
                    solution: solution || 'auto',
                    // don't show control at start playing
                    headless: true,
                    // don't stop playback if player hide
                    persistent: true,
                    modalMenu: modalMenuConfig,
                    mediaId: channelToSend.id,
                    tvChannel: channelToSend,
                    viewport: viewportConfig,
                    extra: channelToSend.extra,
                    exitWithConfirm: true,
                    retryOnError: true,
                    // we play streams
                    stream: true,
                    // set channel volume correction if need
                    volumeCorrection: channelToSend['volume_correction']
                },
                context: context,
                events: playIntentEventsWrapper(channelToSend, index)
            }, function ( error, newContext ) {
                if ( error ) {
                    debug.log('error');
                }

                tv.context = newContext;
            });
            tv.current = channelToSend;
            tv.currentIndex = index;
            if ( params.forceEpg && channelList.$focusItem ) {
                channelList.$focusItem.data.value.getEpg(null, renderEpgList);
            }
        }
    }

    // save and compare previous tv list config
    // if user try to hide tv and go to full screen player we should ask to reset filters (^^_)
    if ( config.compareState ) {
        if ( tv.config.favorite !== tv.lastActiveState.config.favorite ||
            tv.config.genre !== tv.lastActiveState.config.genre ||
            tv.config.search !== tv.lastActiveState.config.search ||
            tv.config.byName !== tv.lastActiveState.config.byName ) {
            // now we should save config to restore it in feature
            tv.lastActiveState.config.favorite = tv.config.favorite;
            tv.lastActiveState.config.genre = tv.config.genre;
            tv.lastActiveState.config.search = tv.config.search;
            tv.lastActiveState.config.byName = tv.config.byName;
        }
    }

    if ( NEED_SILENCE ) {
        NEED_SILENCE = false;
    }
}


function keydownHandlerForOsdInput ( event ) {
    var codes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

    event = event || {};

    if ( codes.indexOf(event.code) > -1 ) {
        sendOsdInputIntent(String.fromCharCode(event.code), false, true);
    }
}


function playIntentEventsWrapper ( channel, index ) {
    return {
        nextChannel: tv.list.length > 1 ? nextChannelCallback : false,
        prevChannel: tv.list.length > 1 ? prevChannelCallback : false,
        onInfoPress: function () {
            sendOsdTvIntent(channel, true);
        },
        close: function () {
            channelList.focusIndex(tv.currentIndex);
            tv.context = null;
            app.lastIntent.silent = false;
            // update some additional info
            // initFooterOnChannelSelect();
            clearTimeout(tv.epgTimeout);
            if ( !channelList.$focusItem ) {
                return;
            }

            tv.epgTimeout = setTimeout(function () {
                if ( !channelList.$focusItem ) {
                    return;
                }

                tv.list[channelList.$focusItem.index].getEpg(null, renderEpgList);
            }, 800);

            if ( app.intents.osdTv ) {
                app.intents.osdTv.close();
                app.intents.osdTv = null;
            }
        },
        onNumberPress: function ( event ) {
            sendOsdInputIntent(event.number, true);
        },
        start: function () {
            clearTimeout(tv.lastChannelTimeout);
            tv.lastChannelTimeout = setTimeout(function () {
                tv.list[index].setLast();
            }, LAST_CHANNEL_TIMEOUT);
        },
        onPip: function () {
            NEED_SILENCE = true;
            tv.context = null;
            tv.current = null;
            tv.currentIndex = null;
        }
    };
}


function sendOsdTvIntent ( channel, attach ) {
    app.intents.osdTv = core.intent({
        action: 'osd-tv',
        data: {
            name: channel.name,
            number: channel.number,
            favorite: channel.favorite,
            pvr: (channel.local_pvr || channel.pvr),
            timeshift: channel.local_timeshift,
            censored: channel.censored || ( channel.genre && channel.genre.censored ),
            // stay on display
            attach: attach
        }
    }, function () { debug.log('send osd intent'); });
}

/**
 * Check if current channel list sorting is the same as played sorted list
 *
 * @return {boolean} state of sorting
 */
function isSortingDifferent () {
    return (
        tv.config.favorite !== tv.lastActiveState.config.favorite
        || tv.config.genre !== tv.lastActiveState.config.genre
        || tv.config.search !== tv.lastActiveState.config.search
        || tv.config.byName !== tv.lastActiveState.config.byName
    );
}

function returnToPlayer ( config ) {

    if ( !tv.current || tv.currentIndex === undefined ) {
        // here check if playback do not start when app start with last censored channel
        // just exit app
        console.log('we do not know current channel');
        mainSet.blur();
        exitModal.show();

        return;
    }

    config = config || {};

    // compare lastPlayed config and current and if it's not equal we must restore it
    if ( isSortingDifferent() && !config.force ) {
        core.notify({
            title: gettext('Reset filters') + ' ?',
            icon: 'alert',
            buttons: [
                {
                    value: gettext('Cancel'),
                    click: function () {
                        // do nothing, magcore-core automatically hide notification and focus tv
                    }
                },
                {
                    // just take first word from reset filter translation :)
                    value: gettext('Reset filters').split(' ')[0],
                    click: function () {
                        resetFilters(tv.lastActiveState.config);

                        tv.config.favorite = tv.lastActiveState.config.favorite;
                        tv.config.genre = tv.lastActiveState.config.genre;
                        tv.config.search = tv.lastActiveState.config.search;
                        tv.config.byName = tv.lastActiveState.config.byName;

                        app.lastIntent.show(app.lastIntent.receiver);
                        app.foreground = false;
                    }
                }
            ],
            timeout: 5000
        });
    } else {
        app.lastIntent.show(app.lastIntent.receiver);
        app.foreground = false;
    }
}


core.addListener('play:channel', function ( data ) {
    var index,
        indexToPlay;

    function findAndPlay ( number ) {
        for ( index = 0; index < tv.list.length; index++ ) {
            if ( tv.list[index].number === number ) {
                indexToPlay = index;
                break;
            }
        }

        if ( indexToPlay !== undefined ) {
            // if channel to play is not censored we should play
            if (
                !tv.list[indexToPlay].censored
                && tv.list[indexToPlay].genre
                && !tv.list[indexToPlay].censored
            ) {
                setChannel(indexToPlay);
                channelList.focusIndex(indexToPlay);
                app.lastIntent.show(app.lastIntent.receiver);
            }
        }
    }

    function processAndPlay ( number ) {
        if ( app.loaded ) {
            findAndPlay(number);
        } else {
            app.once('ready', function () {
                findAndPlay(number);
            });
        }
    }

    // if we have some filters we should reset it first
    if (
        tv.config.favorite
        || tv.config.byName
        || tv.config.genre
        || tv.config.search
    ) {
        resetFilters(false, false, function () {
            processAndPlay(data.number);
        });
    } else {
        processAndPlay(data.number);
    }
});

// if livereload is happened we should clear provider's event handlers
if ( DEVELOP ) {
    window.addEventListener('unload', function () {
        Object.keys(app.provider.events).forEach(function ( eventName ) {
            app.provider.events[eventName] = [];
        });
        Object.keys(window.core.events).forEach(function ( eventName ) {
            window.core.events[eventName] = [];
        });
    } );
}


function onExitAppHandler () {
    if ( app.lastIntent ) {
        app.lastIntent.emit('exit');
    }

    if ( app.intents.osdTv ) {
        app.intents.osdTv.close();
        app.intents.osdTv = null;
    }

    provider.removeListener('channels:delete', deleteChannelsCallback);
    provider.removeListener('channels:add', addChannelsCallback);
    provider.removeListener('channels:modified', updateChannelsCallback);
    provider.removeListener('update', fullUpdateChannelsCallback);
    provider.stopBackgroundCheck();
    exitModal.hide();
    if ( provider.destroy ) {
        provider.destroy();
    }
}

//-----------------------------------------------------------
function makeItem ( icon, text ) {
    return  [
        {
            className: icon
        },
        {
            value: text
        }
    ];
}


function notifyError ( text, duration ) {
    duration = duration || 3000;

    core.notify({
        title: text,
        icon: 'alert',
        type: 'warning',
        timeout: duration
    });
}

module.exports = page;
